<template>
  <a
    class="relative min-h-[220px] h-[220px] hover:no-underline"
    :href="`/school/course/${course.id}/slide/${slide.id}`"
  >
    <li
      class="relative h-full overflow-hidden rounded-[18px] border border-gray-200 bg-white list-none"
    >

      <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6">
        <div class="flex justify-between gap-x-4 py-3">
          <h2 class="text-gray-600 text-lg font-medium capitalize">{{ slide.name }}</h2>
        </div>
      </dl>
    </li>
  </a>
</template>

<script type="text/babel">
export default {
  props: ["course", "slide"],
  methods: {
    getDate(timestamp) {
      return moment(timestamp).format("D. MMM. YYYY");
    },
  },
};
</script>
